import { createContext, useMemo, useState } from "react";

export const TableHeaderContext = createContext();
export const TableHeaderDispatchContext = createContext();

const TableHeaderProvider = (props) => {
    const [order, setOrder] = useState({orderBy: null, direction: null});  

    const value = useMemo(
        () => ({ order, setOrder }), 
        [order]
      );

    return (
        <TableHeaderContext.Provider value={value}>
            {props.children}
        </TableHeaderContext.Provider>
    )
}

export default TableHeaderProvider;